const right = true;
const questions = [
    {
        image: '/images/questions/level_2/1-hacienda.jpg',
        statement: '¿Qué nombre recibió la hacienda de Alonso Fernández de Lugo tras la conquista?',
        answers: [
            { text: "Los Príncipes", right },
            { text: "El Marqués" },
            { text: "Los Adelantados" }
        ]
    },
    {
        image: '/images/questions/level_2/2-nucleo-principal.jpg',
        statement: '¿Cuál fue el núcleo principal que dio origen al Realejo Alto?',
        answers: [
            { text: "Caserío de la iglesia del Apóstol Santiago", right },
            { text: "Caseríos La Montañeta y El Jardín" },
            { text: "Tierras de Palo Blanco" }
        ]
    },
    {
        image: '/images/questions/level_2/3-siglo.jpg',
        statement: '¿En qué siglo fue fundada la iglesia de Santiago Apóstol en Los Realejos?',
        answers: [
            { text: "Siglo XV", right },
            { text: "Siglo XVII" },
            { text: "Siglo XVIII" }
        ]
    },
    {
        image: '/images/questions/level_2/4-primo-rivera.jpg',
        statement: '¿Quién promovió la unión de los municipios en 1928?',
        answers: [
            { text: "Miguel Primo de Rivera", right },
            { text: "Alonso Fernández de Lugo" },
            { text: "Antonio de Viana" }
        ]
    },
    {
        image: '/images/questions/level_2/5-ra.jpg',
        statement: '¿Cómo se llamaba el último alcalde de Realejo Alto antes de la fusión?',
        answers: [
            { text: "Nicolás González del Carmen", right },
            { text: "Manuel Pérez Gutiérrez" },
            { text: "Francisco Javier Hernández" }
        ]
    },
    {
        image: '/images/questions/level_2/7-primer-intento.jpg',
        statement: '¿Cuánto duró el primer intento de fusión entre Los Realejos Alto y Bajo?',
        answers: [
            { text: "9 meses", right },
            { text: "12 meses" },
            { text: "3 meses" }
        ]
    },
    {
        image: '/images/questions/level_2/8-intentos.jpg',
        statement: '¿Cuántos intentos de fusión municipal hubo en Los Realejos en el siglo XIX?',
        answers: [
            { text: "Dos", right },
            { text: "Tres" },
            { text: "Uno" }
        ]
    },
    {
        image: '/images/questions/level_2/9-primer-alcalde.jpg',
        statement: '¿Cómo se llama el primer alcalde de Los Realejos después de la fusión?',
        answers: [
            { text: "Domingo Luis Estrada", right },
            { text: "Nicolás González del Carmen" },
            { text: "Óscar González Siverio" }
        ]
    },
    {
        image: '/images/questions/level_2/10-incendio.jpg',
        statement: '¿Qué evento histórico fue el detonante de la fusión de ambos municipios?',
        answers: [
            { text: "Incendio exconvento de San Andrés y Santa Mónica", right },
            { text: "Visita de Primo de Rivera" },
            { text: "Gran incendio forestal" }
        ]
    },
    {
        image: '/images/questions/level_2/11-casa-cultura.jpg',
        statement: '¿Cuándo se inaugura la Casa de la Cultura de Los Realejos?',
        answers: [
            { text: "1987", right },
            { text: "1979" },
            { text: "1994" }
        ]
    },
    {
        image: '/images/questions/level_2/12-drago.jpg',
        statement: '¿Dónde se encuentra este drago centenario Realejero?',
        answers: [
            { text: "Cementerio San Francisco", right },
            { text: "Siete Fuentes" },
            { text: "Iglesia de La Concepción" }
        ]
    },
];
export default questions;
